enum ModelStatusEnum {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}

export default ModelStatusEnum
